import React, { useRef, useEffect } from "react";

const GoogleAddressInput = ({ value, onChange }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!window.google) return;

    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ["geocode"],
      componentRestrictions: { country: "au" }, // Only Australia
    });

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place.formatted_address) {
        onChange({ target: { name: "address", value: place.formatted_address } });
      }
    });
  }, []);

  return (
    <input
      ref={inputRef}
      type="text"
      className="form-control"
      placeholder="Enter Address"
      name="address"
      value={value}
      onChange={onChange}
      required
    />
  );
};

export default GoogleAddressInput;
